import React from 'react';
import Switch from '../ui/Switch';
import { useSaveToast } from '../ui/SaveToast';
import { useSelfHelpPreference } from '../../lib/selfHelpPreference';

export default function SelfHelpPreferenceCard({ client, userId }) {
    const { enabled, loaded, saving, setEnabled } = useSelfHelpPreference(userId, client);
    const toast = useSaveToast();
    async function choose(next) {
        try { await setEnabled(next); toast.saved(); }
        catch (error) { toast.failed(error?.message || 'Could not save your Self-Help choice.'); }
    }
    return <section className="ia-d2-card flex flex-col gap-3" aria-label="Self-Help">
        <h3 className="text-base font-bold">Self-Help</h3>
        <span className="flex items-center gap-3"><span>Show Self-Help (?) icons</span><Switch label="Show Self-Help (?) icons" checked={enabled} disabled={!loaded || saving || !userId} onChange={choose} /></span>
        <p className="text-sm">Show explanations beside controls. Hover with a mouse, or tap on a phone or tablet.</p>
    </section>;
}
